const photoButtons=[...document.querySelectorAll('.thumb')];
const stage=document.querySelector('.v10-stage');
const image=document.querySelector('#product-image');
const design=document.querySelector('#gallery-design');
const count=document.querySelector('#gallery-count');
const recipes=JSON.parse(document.querySelector('#catalog-recipes').textContent);
let activePhoto=0;
function renderPhoto(index){
 activePhoto=(index+recipes.length)%recipes.length;
 const item=recipes[activePhoto];
 image.src=item.image;image.alt=item.alt;
 stage.dataset.layout=item.layout;design.innerHTML=item.design;
 count.textContent=`${activePhoto+1} / ${recipes.length}`;
 document.querySelector('#gallery-title').textContent=item.title;
 document.querySelector('#gallery-copy').textContent=item.copy;
 photoButtons.forEach((button,i)=>{button.classList.toggle('active',i===activePhoto);button.setAttribute('aria-pressed',String(i===activePhoto));});
 const button=photoButtons[activePhoto],strip=button.parentElement;
 if(button.offsetLeft<strip.scrollLeft||button.offsetLeft+button.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:button.offsetLeft,behavior:'smooth'});
}
photoButtons.forEach((button,index)=>button.addEventListener('click',()=>renderPhoto(index)));
document.querySelector('.gallery-arrow.previous').addEventListener('click',()=>renderPhoto(activePhoto<0?recipes.length-1:activePhoto-1));
document.querySelector('.gallery-arrow.next').addEventListener('click',()=>renderPhoto(activePhoto<0?0:activePhoto+1));
let startX=0,startY=0;
stage.addEventListener('touchstart',e=>{startX=e.changedTouches[0].clientX;startY=e.changedTouches[0].clientY;},{passive:true});
stage.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-startX,dy=e.changedTouches[0].clientY-startY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))renderPhoto(activePhoto+(dx<0?1:-1));},{passive:true});
document.querySelectorAll('.color-option input').forEach(input=>input.addEventListener('change',()=>{
 activePhoto=-1;image.src=JSON.parse(document.querySelector('#hg-gallery-assets').textContent)[input.dataset.image];image.alt='Set Beauty Sleep, color '+input.dataset.color;
 stage.dataset.layout='editorial';design.innerHTML='';
 photoButtons.forEach(button=>{button.classList.remove('active');button.setAttribute('aria-pressed','false');});count.textContent='Color: '+input.dataset.color;
 const href='https://www.higlowy.com/products/higlowy%E2%84%A2-noise-cancelling-sleep-earplugs-1?variant='+encodeURIComponent(input.value);
 document.querySelector('#hg-purchase [name=id]').value=input.value;
 updatePurchase(input.value);
 syncBundleColour(input.dataset.color);
 document.querySelector('#gallery-title').textContent=input.dataset.color;document.querySelector('#gallery-copy').textContent='Tapones, cuatro tallas y estuche.';
}));
(()=>{
 const form=document.querySelector('#hg-purchase');
 const primary=form?.querySelector('.product-buy');
 const bar=document.querySelector('.mobile-buy');
 const sticky=bar?.querySelector('button');
 if(!form||!primary||!bar||!sticky)return;
 sticky.addEventListener('click',()=>{if(!primary.disabled)primary.click();});
 let chosen=false,primaryVisible=false;
 const update=()=>{
  const passed=form.getBoundingClientRect().top<0;
  bar.classList.toggle('show',!primaryVisible&&(chosen||passed));
  sticky.disabled=primary.disabled;
  sticky.setAttribute('aria-busy',String(primary.disabled));
 };
 new IntersectionObserver(entries=>{primaryVisible=entries[0].isIntersecting;update();},{threshold:0}).observe(primary);
 form.addEventListener('click',event=>{
  if(event.target.closest('kaching-bundle,.kaching-bundles__bar')){chosen=true;update();}
 });
 form.addEventListener('change',event=>{
  if(event.target.closest('kaching-bundle,.kaching-bundles__bar')){chosen=true;update();}
 });
 new MutationObserver(update).observe(primary,{attributes:true,attributeFilter:['disabled']});
 window.addEventListener('scroll',update,{passive:true});
 update();
})(); 
const dialog=document.querySelector('#gallery-dialog'),scrollArea=dialog.querySelector('.image-dialog-scroll');
document.querySelector('.gallery-zoom').addEventListener('click',()=>{
 const clone=stage.cloneNode(true);clone.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));clone.classList.add('zoom-stage');
 scrollArea.replaceChildren(clone);dialog.removeAttribute('data-zoomed');document.querySelector('#image-scale').textContent='Ver más grande +';dialog.showModal();
});
document.querySelector('#image-close').addEventListener('click',()=>dialog.close());
document.querySelector('#image-scale').addEventListener('click',event=>{const expanded=dialog.getAttribute('data-zoomed')==='true';dialog.setAttribute('data-zoomed',String(!expanded));event.currentTarget.textContent=expanded?'Ver más grande +':'Ajustar imagen −';});
document.querySelector('#year').textContent=new Date().getFullYear();
const requested=new URLSearchParams(location.search).get('color');
const colors={rosa:'45892687233133',crema:'67707775942765',negro:'67710951817325'};
if(requested&&colors[requested]){const input=document.querySelector('.color-option input[value="'+colors[requested]+'"]');if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}}

function updatePurchase(id){
 const data=JSON.parse(document.querySelector('#hg-product-data').textContent);
 const variant=data.variants.find(v=>String(v.id)===String(id)); if(!variant)return;
 const formatted=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(variant.price/100);
 const price=document.querySelector('[data-hg-price]');if(price)price.innerHTML=formatted+' <span>Set completo</span>';
 const stickyPrice=document.querySelector('.mobile-buy strong');if(stickyPrice)stickyPrice.textContent=formatted;
 document.querySelectorAll('.product-buy').forEach(b=>{b.disabled=!variant.available;});
 const url=new URL(location.href);url.searchParams.set('variant',id);history.replaceState({},'',url);
}
const variantParam=new URLSearchParams(location.search).get('variant');
const initial=document.querySelector('.color-option input[value="'+(variantParam||document.querySelector('#hg-purchase [name=id]').value)+'"]');
if(initial){initial.checked=true;initial.dispatchEvent(new Event('change',{bubbles:true}));}

function syncBundleColour(colour){
 document.querySelectorAll("#hg-purchase .kaching-bundles__bar").forEach(bar=>{
  const select=bar.querySelector(".kaching-bundles__bar-variant-select");
  if(select&&select.value!==colour&&[...select.options].some(option=>option.value===colour)){select.value=colour;select.dispatchEvent(new Event("change",{bubbles:true}));}
 });
}
const bundleReady=new MutationObserver(()=>{if(document.querySelectorAll("#hg-purchase .kaching-bundles__bar").length===3){const chosen=document.querySelector(".color-option input:checked");if(chosen)syncBundleColour(chosen.dataset.color);bundleReady.disconnect();}});
bundleReady.observe(document.querySelector("#hg-purchase"),{childList:true,subtree:true});


(()=>{
 const form=document.querySelector('#hg-purchase');
 if(!form)return;
 const assets=JSON.parse(document.querySelector('#hg-gallery-assets').textContent);
 const imageByColour={'Rosa HiGlowy':assets['visual-v24/rosa.webp'],'Blanco crema':assets['originales-v20/crema.webp'],'Negro':assets['visual-v24/negro.webp']};
 let queued=false;
 const enhance=()=>{
  queued=false;
  form.querySelectorAll('.kaching-bundles__bar').forEach((bar,barIndex)=>{
   const group=bar.querySelector('.kaching-bundles__bar-variants');
   if(!group)return;
   const title=group.querySelector('.kaching-bundles__bar-variant-names');
   if(title&&title.textContent!==form.dataset.packColorTitle)title.textContent=form.dataset.packColorTitle;
   if(!group.querySelector('.hg-pack-color-hint')){
    const hint=document.createElement('p');hint.className='hg-pack-color-hint';hint.textContent=form.dataset.packColorHint;
    if(title)title.after(hint);else group.prepend(hint);
   }
   group.querySelectorAll('.kaching-bundles__bar-variant-selector-wrapper').forEach((row,index)=>{
    const select=row.querySelector('.kaching-bundles__bar-variant-select');
    if(!select)return;
    const labelText=form.dataset.packPairLabel.replace('__N__',String(index+1));
    if(!select.id)select.id='hg-pack-colour-'+barIndex+'-'+index;
    let label=row.querySelector('.hg-pack-pair-label');
    if(!label){label=document.createElement('label');label.className='hg-pack-pair-label';label.htmlFor=select.id;select.before(label);}
    if(label.textContent!==labelText)label.textContent=labelText;
    if(select.getAttribute('aria-label')!==labelText)select.setAttribute('aria-label',labelText);
    const photo=row.querySelector('.kaching-bundles__bar-variant-image'),url=imageByColour[select.value];
    if(photo&&url){if(photo.getAttribute('src')!==url)photo.setAttribute('src',url);if(photo.hasAttribute('srcset'))photo.removeAttribute('srcset');if(photo.alt!==select.value)photo.alt=select.value;}
   });
  });
 };
 const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(enhance);}};
 const watch=new MutationObserver(schedule);
 watch.observe(form,{subtree:true,childList:true,attributes:true,attributeFilter:['src','srcset','data-value']});
 form.addEventListener('change',event=>{
  if(!event.target.matches('.kaching-bundles__bar-variant-select'))return;
  schedule();
  const url=imageByColour[event.target.value];
  if(url){const image=document.querySelector('#product-image');image.src=url;image.alt=event.target.value;document.querySelector('#gallery-title').textContent=event.target.value;}
 });
 enhance();
})();
